import "src/sentry/setupSentry.ts";
import "src/config/i18nConfig.ts";
import "src/config/dayjsConfig.ts";
import "src/config/zodConfig.ts";
import "src/config/highchartsConfig.ts";
import "src/config/domPurifyConfig.ts";
import "src/polyfills.ts";
import React from "react";
import ReactDOM from "react-dom/client";
import "src/styles/css/index.scss";
import { App } from "./App";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { applyLocalSettings } from "./localSettings/utils";
import { setupInitialBackgroundMessageEventHandler } from "./notifications/firebaseMessaging";
import { applyDomManipulationWorkaround } from "./utils/domManipulationWorkaround";
import { dom as fontawesomeDom, library as fontawesomeLibrary } from "@fortawesome/fontawesome-svg-core";
import { LicenseInfo as MuiLicenceInfo } from "@mui/x-license";

MuiLicenceInfo.setLicenseKey(
	"40f045e01e0715d5cca595c3ce8bff7aTz0xMzIyOTQsRT0xODE5MjM4Mzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MSxBVD1zaW5nbGUsS1Y9Mg==",
);

applyLocalSettings(false);
applyDomManipulationWorkaround();

fontawesomeLibrary.add(far, fas);
fontawesomeDom.watch();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);

setupInitialBackgroundMessageEventHandler();
